// Configurações de ambiente da aplicação
export const config = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || 'https://apicargo.sendingto.com/',
  APP_NAME: process.env.REACT_APP_APP_NAME || 'SendingTo Express',
  APP_VERSION: '1.0.0',
  ENVIRONMENT: process.env.NODE_ENV || 'development'
};

// Configurações específicas por ambiente
export const isDevelopment = config.ENVIRONMENT === 'development';
export const isProduction = config.ENVIRONMENT === 'production';

// Configurações da API
export const apiConfig = {
  baseURL: config.API_BASE_URL,
  timeout: 10000, // 10 segundos
  retryAttempts: 3,
  endpoints: {
    login: '/api/v1/login',
    logout: '/api/v1/logout',
    refresh: '/api/v1/refresh',
    profile: '/api/v1/profile'
  }
};
